/** Liens internes après login — pas d’open-redirect (chemins stricts uniquement). */

const STORAGE_KEY = 'collect_invite_return';

export function safeCollectContributorPath(raw: string | null | undefined): string | null {
    if (!raw || typeof raw !== 'string') return null;
    const path = raw.trim().split('#')[0].split('?')[0];
    if (!path.startsWith('/') || path.includes('//') || path.includes('..')) return null;
    if (!/^\/r\/[0-9a-fA-F-]{10,}$/i.test(path)) return null;
    return path;
}

/** Workspace propriétaire collecte — même URL que dans l’app après connexion. */
export function safeDataCollectWorkspacePath(raw: string | null | undefined): string | null {
    if (!raw || typeof raw !== 'string') return null;
    const path = raw.trim().split('#')[0].split('?')[0];
    if (!path.startsWith('/') || path.includes('//') || path.includes('..')) return null;
    if (!/^\/process\/data-collect\/[a-zA-Z0-9_-]{8,128}$/.test(path)) return null;
    return path;
}

/** Handoff Office → Famla : /map/new?session=<uuid> */
export function safeOfficeHandoffPath(raw: string | null | undefined): string | null {
    if (!raw || typeof raw !== 'string') return null;
    const trimmed = raw.trim();
    if (!trimmed.startsWith('/') || trimmed.includes('//') || trimmed.includes('..')) return null;

    try {
        const url = new URL(trimmed, 'https://local.invalid');
        if (url.pathname !== '/map/new') return null;
        const session = url.searchParams.get('session');
        if (!session || !/^[0-9a-fA-F-]{10,}$/i.test(session)) return null;
        return `/map/new?session=${encodeURIComponent(session)}`;
    } catch {
        return null;
    }
}

function safePostLoginRedirectPath(raw: string | null | undefined): string | null {
    return (
        safeCollectContributorPath(raw) ??
        safeDataCollectWorkspacePath(raw) ??
        safeOfficeHandoffPath(raw)
    );
}

/** Appelé sur /auth/login?redirect=… pour survivre à un flux OAuth qui perd la query. */
export function persistLoginRedirectQuery(redirectQueryParam: string | null | undefined): void {
    const safe = safePostLoginRedirectPath(redirectQueryParam);
    if (safe) sessionStorage.setItem(STORAGE_KEY, safe);
}

export function stashCollectInviteReturn(path: string): void {
    const safe = safePostLoginRedirectPath(path);
    if (safe) sessionStorage.setItem(STORAGE_KEY, safe);
}

/** Query ?redirect= puis secours sessionStorage (OAuth / perte de query). Ne supprime pas le storage. */
export function peekCollectInviteReturn(redirectQueryParam: string | null): string | null {
    const fromQuery = safePostLoginRedirectPath(redirectQueryParam);
    if (fromQuery) return fromQuery;
    return safePostLoginRedirectPath(sessionStorage.getItem(STORAGE_KEY));
}

export function clearCollectInviteReturnStorage(): void {
    sessionStorage.removeItem(STORAGE_KEY);
}
